<template>
    <div>
        <vue-tel-input defaultCountry="fr" :autoDefaultCountry="false" :autoFormat="false" v-model="model" :inputOptions="inputOptions" :class="{ 'small': small, 'error': hasError }" @input="input" />
    </div>
</template>

<script>
    import { VueTelInput } from 'vue-tel-input'

    export default {
        components: {
            VueTelInput
        },
        props: {
            hasError: Boolean,
            placeholder: String,
            small: Boolean,
            value: String
        },
        data() {
            return {
                inputOptions: {
                    placeholder: this.placeholder
                }
            }
        },
        computed: {
            model: {
                get() {
                    return this.value ? this.value : ''
                },
                set() {
                }
            },
        },
        methods: {
            input(val, phone) {
                this.$emit('input', phone.number ? phone.number : val)
            }
        }
    }
</script>